export default {
  template: require('./settings.component.html').default
}
